import React from "react"
import Header from 'components/TBB/Header'
import Footer from 'components/TBB/Footer'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from "gatsby"
import { CookiesProvider } from "react-cookie"
import GclidCookie from 'src/utils/GclidCookie'

export default function Layout({ children }){
  const { settings } = useStaticQuery(graphql`
  query Settings {
    settings: allStoryblokEntry(filter: {field_component: {eq: "settings"}}) {
      edges {
        node {
          name
          full_slug
          content
        }
      }
    }
  }
  `)
  let content = JSON.parse(settings.edges[0].node.content)
  let parsedSetting = Object.assign({}, content, {content: content})

  return (
    <div className="bg-[#EEF2FE] font-poppins">
      <Helmet>
        <script src="https://kit.fontawesome.com/e86587c99a.js" crossorigin="anonymous"></script>
      </Helmet>
      <Header settings={parsedSetting} />
      <CookiesProvider>
        <GclidCookie/>
        <main>{children}</main>
      </CookiesProvider>
      <Footer settings={parsedSetting} />
    </div>
  )
}